import { useEffect, useState } from "react";

/**
 * A resend deadline, counted against the clock as on SignIn (owner
 * 2026-10-23: every send-code screen waits, then allows a resend).
 */
export function useResendTimer() {
  const [until, setUntil] = useState(0);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (until <= now) return;
    const t = window.setTimeout(() => setNow(Date.now()), 1000);
    return () => window.clearTimeout(t);
  }, [until, now]);
  const start = (seconds: number) => {
    const t = Date.now();
    setNow(t);
    setUntil(t + seconds * 1000);
  };
  return { left: Math.max(0, Math.ceil((until - now) / 1000)), start };
}
